import {lazy, useEffect} from "react";
import {styled} from "@mui/material/styles";
import {Box, Skeleton } from "@mui/material";
import Page from "../../components/portal/Page";
import {useSeoData} from "../../hooks/useSeoData";
import useGetBanners from "../../hooks/portal/useGetBanners";

const Machines = lazy(() => import ('../../components/portal/home/Machines'))
const Sell = lazy(() => import ('../../components/portal/home/Sell'))
const Services = lazy(() => import ('../../components/portal/home/Services'))
const Testimonials = lazy(() => import ('../../components/portal/home/Testimonials'))
const ContactForm = lazy(() => import ('../../components/portal/home/ContactForm'))
const Guarantee = lazy(() => import ('../../components/portal/home/Guarantee'))
const CarouselBasic3 = lazy(() => import ('../../components/portal/carousel/CarouselBasic3'))


// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 88;

const RootStyle = styled(Page)(({theme}) => ({
  height: "100%",
  width: "100%",
  position: "relative",
  paddingTop: APP_BAR_MOBILE,
  [theme.breakpoints.up("md")]: {
    paddingTop: APP_BAR_DESKTOP,
  },
}));

// ----------------------------------------------------------------------

export default function LandingPage() {
  const comeFromQuestions = JSON.parse(sessionStorage.getItem('comeFromQuestions'))
  const {seo} = useSeoData('home')
  const {banners, loading} = useGetBanners('home')

  function filterMainBanners(arr) {
    return arr.filter((item) => item.Codigo === 'main').sort((a, b) => a.Orden - b.Orden);
  }

  useEffect(() => {
    const asyncScroll = () => {
      const container = document.getElementById('contact')
      window.scrollTo(0, container.offsetTop - 40);
    }
    if (comeFromQuestions) {
      asyncScroll();
    }
    return () => {
      sessionStorage.removeItem('comeFromQuestions');
    }
  }, [])

  return (
    <RootStyle title={seo.Titulo} meta={seo.Meta} id="move_top">
      <h1 style={{ fontSize: '10px', padding: '1rem' }}>{seo.H1}</h1>
      {
        banners.length > 0 && !loading &&
        <Box sx={{overflow: "hidden", position: "relative"}}>
          <CarouselBasic3 slidesToShow={1} items={filterMainBanners(banners)} type='banner'/>
        </Box>
      }
      {loading && <Skeleton width='100vw' height={600}/>}
      <Guarantee/>

      <Machines/>
      {/*{*/}
      {/*  banners.length > 0 && !loading &&*/}
      {/*  <img*/}
      {/*    loading='lazy'*/}
      {/*    src={banners.filter(x => x.Codigo === 'second')[0].URL_Desktop}*/}
      {/*    width="100%"*/}
      {/*    height='100%'*/}
      {/*    alt={banners.filter(x => x.Codigo === 'second')[0].ALT}*/}
      {/*  />*/}
      {/*}*/}
      {/*{loading && <Skeleton width='100vw' height={400}/>}*/}
      {
        loading &&
        <Box display='flex' justifyContent='center'>
          <Skeleton variant='rectangular' width={300} height={200}/>
        </Box>
      }
        <Sell />
      {
        banners.length > 0 && !loading &&
        <img
          loading='lazy'
          src={banners.filter(x => x.Codigo === 'third')[0].URL_Desktop}
          width="100%"
          height="100%"
          alt={banners.filter(x => x.Codigo === 'third')[0].ALT}
        />
      }
      {loading && <Skeleton width='100vw' height={400}/>}
        <Services />
      {
        banners.length > 0 && !loading &&
        <img
          loading='lazy'
          src={banners.filter(x => x.Codigo === 'fourth')[0].URL_Desktop}
          width="100%"
          height="100%"
          alt={banners.filter(x => x.Codigo === 'fourth')[0].ALT}
        />
      }
      { loading && <Skeleton width='100vw' height={400}/>}

      <Testimonials/>

      {
        banners.length > 0 && !loading &&
        <img
          loading='lazy'
          src={banners.filter(x => x.Codigo === 'fifth')[0].URL_Desktop}
          width="100%"
          height="100%"
          alt={banners.filter(x => x.Codigo === 'fifth')[0].ALT}
        />
      }
      {loading && <Skeleton width='100vw' height={400}/>}

      <Box id='contact'>
        <ContactForm/>
      </Box>
    </RootStyle>
  );
}
